(()=>{
  const contentBlockArray = Array.from(document.getElementsByClassName('content-block'));
  contentBlockArray.forEach( container => {

    const hotspotBtns = Array.from(container.getElementsByClassName('hotspot-btn'));

    hotspotBtns.forEach( (el, index) => {
      el.addEventListener('click', e => {
        let popup = container.getElementsByClassName('hotspot-popup')[index];

        if(el.classList.contains('selected')){
          popup.classList.remove('open');
          el.classList.remove('selected');
        } else {
          hotspotBtns.forEach(btn => {
            btn.classList.remove('selected');
          })
          Array.from(container.getElementsByClassName('hotspot-popup')).forEach(el => {
            el.classList.remove('open');
          })

          popup.classList.toggle('open');
          el.classList.toggle('selected');
          positionPopup(el, popup, container);
        }

      })
    })
    if(container.getElementsByClassName('content-block__media').length > 0){
      container.getElementsByClassName('content-block__media')[0].addEventListener('click', e => {
        hotspotBtns.forEach(btn => {
          btn.classList.remove('selected');
        })
        Array.from(container.getElementsByClassName('hotspot-popup')).forEach(el => {
          el.classList.remove('open');
        })
      })
    }

  })
  function positionPopup(hotspotBtnEl, popupEl, containerEl){
    let hotspot = hotspotBtnEl.getBoundingClientRect();
    let popup = popupEl.getBoundingClientRect();
    let container = containerEl.getBoundingClientRect();
    let hotspotArrow = popupEl.getElementsByClassName('hotspot-arrow')[0];
    let spotMargin = 20;

    if(hotspot.top + (hotspot.height / 2) < popup.height / 2 || hotspot.top + (hotspot.height / 2) + (popup.height / 2) > window.innerHeight || checkMobile()){
      // if popup to the right or left get cut off at the top or bottom
      // show above or below
      let leftPixels = (hotspot.left - container.left) + (hotspot.width / 2);
      popupEl.style.left = ((leftPixels) / container.width) * 100 + "%";   

      hotspotArrow.style.left = "50%";

      if(hotspot.top < popup.height) {
        //show below point
        //console.log('show below point')

        let topPixels =  hotspot.bottom + popup.height / 2 + spotMargin - container.top 
        popupEl.style.top =   (topPixels / container.height) * 100 + "%";

        hotspotArrow.style.top = "0%";

      } else {
        //show above point
        //console.log('show above point')
        let topPixels =  hotspot.top - popup.height / 2 - spotMargin - container.top 
        popupEl.style.top =   (topPixels / container.height) * 100 + "%";

        hotspotArrow.style.top = "100%";
      }
    } else {
      // show on left or right
      let topPixels =  (hotspot.top + hotspot.height / 2 ) - container.top 
      popupEl.style.top =   (topPixels / container.height) * 100 + "%";
      hotspotArrow.style.top = "50%";

      if(hotspot.left  > window.innerWidth - hotspot.right ){
        // show on left
        //console.log('show left of point')
        //console.log(container.left)

        let leftPixels = hotspot.left - container.left - popup.width + (popup.width / 2) - spotMargin;
        popupEl.style.left = (leftPixels / container.width) * 100 + "%";   

        hotspotArrow.style.left = "100%";
      } else {
        // show on right
        //console.log('show right of point')

        let leftPixels = hotspot.left - container.left + hotspot.width + spotMargin + popup.width / 2;
        popupEl.style.left = (leftPixels / container.width) * 100 + "%";   

        let hotspotLeftPixels = leftPixels - popup.width / 2;
        hotspotArrow.style.left = "0%";
      }
    }
    function checkMobile(){
      if(window.innerWidth < 769){
        let hotspotCenterLeft =  hotspot.left + hotspot.width / 2;
        if( hotspotCenterLeft < window.innerWidth / 2 ){
          // if hotspot is on the left side

          if(window.innerWidth - hotspotCenterLeft < popup.width + spotMargin + 15  ){
            return true;
          } else {
            return false;
          }

        } else {
          // if hotspot is on the right side

          if(hotspotCenterLeft < popup.width + spotMargin + 15  ){
            return true;
          } else {
            return false;
          }

        }
      } else {
        return false;
      }
    }
  }
})();